$('a:not([href^="tel:"])').on('click tap', function(e) {

  var ref = location.href;
  var url = $(this).attr('href');
  var window_scroll_num = $('body').css('top');
  window_scroll_num = window_scroll_num.replace(/[^0-9]/g, '');

  if( ref.indexOf(url.replace(/#.*$/, '')) != -1 && url.indexOf('#') != -1 && url != '#' ) {

    var speed = 300;
    var href= url.match(/#.*$/);
    var target = href[0];
    var position = $(target).offset().top - $('.js-header').outerHeight() + Number(window_scroll_num);
    $('body, html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  }
});

$(window).on('load',function() {

    // 立ち退きについてパラメータ対応
    $('.js-loader').fadeOut();
    $('html').removeClass('hidden');

    // top 立ち退きについてのもっと見るボタン
    var moreNum = 5;
    var list = $('.p-index__category-list-item').length;
    if (list < moreNum) {
        $('.p-index__category-more').addClass('none');
    }
});

  $(function() {
    $('.js-hamburger').click(function() {
        $('html').toggleClass('hidden');
        $(this).toggleClass('open');
        $(this).find('.g-header__main-menu-contact-link-hamburger').toggleClass('open');
        $(this).find('.g-header__main-menu-contact-link-txt').toggleClass('close');
        $('.g-header__menu-inner').toggleClass('open');
        $('.g-header__main-menu-contact-link.line').toggleClass('close');
        $('.g-header__main-logo').toggleClass('open');
    });
    $('.js-modal__close').click(function() {
        $('html').toggleClass('hidden');
        $('.g-header__main-menu-contact-link-hamburger').toggleClass('open');
        $('.g-header__main-menu-contact-link-txt.tx-lightblue').toggleClass('close');
        $('.g-header__menu-inner').toggleClass('open');
        $('.g-header__main-menu-contact-link.line').toggleClass('close');
    });
    $('.js-service').click(function() {
        $(this).find('.g-header__menu-list-item-link').toggleClass('open');
        $(this).find('.g-header__menu-list-item-service').slideToggle(300);
        $(this).find('.vertical').toggleClass('none');
    });

    $('.js-trouble').click(function() {
      let num = $(this).attr('data-tab');

      $('.js-trouble').removeClass('open');
      $('.js-trouble-item').removeClass('open');

      $(this).addClass('open');
      $('.js-trouble-item').eq(num).addClass('open');

    });

    $('.js-trouble.divorce').click(function() {
        $('.p-index__top-trouble-main-inner').removeClass('open');
        $('.js-top__divorce').addClass('open');
    });
    $('.js-trouble.work').click(function() {
        $('.p-index__top-trouble-main-inner').removeClass('open');
        $('.js-top__work').addClass('open');
    });
    $('.js-trouble.slandering').click(function() {
        $('.p-index__top-trouble-main-inner').removeClass('open');
        $('.js-top__slandering').addClass('open');
    });
    $('.js-trouble.scam').click(function() {
        $('.p-index__top-trouble-main-inner').removeClass('open');
        $('.js-top__scam').addClass('open');
    });
    $('.js-trouble.other').click(function() {
        $('.p-index__top-trouble-main-inner').removeClass('open');
        $('.js-top__other').addClass('open');
    });
    $('.js-more').click(function() {
      $(this).parent().siblings().find('.js-more__content').toggleClass('open');
      $(this).parent().siblings().find('.js-more__content').slideToggle(500);
      $(this).parent().siblings().find('.js-more__solution').slideToggle(500);
      $(this).parent().siblings('.js-more__content').toggleClass('open');
      $(this).parent().siblings('.js-more__content').slideToggle(500);
      $(this).parent().siblings('.js-more__solution').slideToggle(500);

      $(this).find('.js-more__default').toggleClass('none');
      $(this).find('.js-more__txt').toggleClass('none');
      $(this).find('.js-more__close').toggleClass('none');
  });
    $('.js-more-service').click(function() {
        $(this).parent().siblings('.js-more-service__content').toggleClass('open');
        $(this).parent().siblings('.js-more-service__content').slideToggle(500);
        $(this).parent().siblings().find('.js-more-service__content').toggleClass('open');
        $(this).parent().siblings().find('.js-more-service__content').slideToggle(500);
        $(this).parent().siblings().find('.js-more-service__solution').slideToggle(500);
        $(this).find('.js-more-service__default').toggleClass('none');
        $(this).find('.js-more-service__txt').toggleClass('none');
        $(this).find('.js-more-service__rod').toggleClass('none');
        $(this).find('.js-more-service__close').toggleClass('none');
    });
    $('.js-faq').click(function() {
        $(this).find('.p-faq__main-list-item-answer').slideToggle(500);
        $(this).toggleClass('open');
    });

    $('#js-select').change(function() {
      var category = $(this).val();
      var home_url = window.location.href;
      home_url = home_url.split('/case');

      if(category === '') {
        window.location.href = home_url[0] + '/case/';
      } else {
        window.location.href = home_url[0] + '/case_category/' + category;
      }
    });
    if($('.swiper-member' + ' .swiper-slide').length === 1) {
        $('.p-about__gladiators-main-slide-btn').css('display', 'none');
        $('.swiper-slide').addClass('swiper-slide-thumb-active');
    };
    $(window).on('load', function() {
      if( location.hash && $(location.hash)[0] ) {
        var hash = location.hash;
        setTimeout(function() {
          $('body, html').animate({ scrollTop: $(hash).offset().top - $('.js-header').outerHeight() }, 0, 'linear');
        }, 300 );

      }
    });
    var href = location.protocol + '//' + location.hostname + location.pathname;
    var hash = location.hash;
    if(href === 'https://fullscratch.xsrv.jp/demo/gladiator/about/member/') {
        if(hash !== '') {
            if (window.matchMedia('(max-width: 767px)').matches) {
                var target = $('.js-target').offset().top - 50;
            } else {
                target = $('.js-target').offset().top - 70;
            }
            $('html,body').scrollTop(target);
        }
    }

    var window_width = window.innerWidth;

    if( $('.js-column-slider .swiper-slide').length > 1 && window_width < 769) {

      var swiper = new Swiper('.js-column-slider', {
        loop: true,
        speed: 1000,
        slidesPerView: 1.35,
        loopAdditionalSlides: 1,
        spaceBetween: 10,
        centeredSlides: true,

        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },

        pagination: {
          el: '.js-column-slider-pagination',
          clickable: true,
        },

        navigation: {
          nextEl: '.js-column-slider-next',
          prevEl: '.jjs-column-slider-prev',
        },

      });
    }


    setTimeout(function() {

      $('.js-column-mh').matchHeight({
        byRow: true
      });

      $('.js-category-mh').matchHeight({
        byRow: true
      });

    },300)

    loadFile('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;1,700&display=swap', 'css');
    loadFile('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css', 'css');

});

//ヘッダーがKVを超えたら
$(window).on('load scroll',function(){
  let kv_height = $('.js-indexkv').outerHeight();
  let scroll = $(window).scrollTop() + $('.js-header').outerHeight();

  if(scroll > kv_height) {
    $('.js-header').addClass('is-overed');
  } else {
    $('.js-header').removeClass('is-overed');
  }

})


function loadFile(src, type) {

  if( type == 'js' ) {
    $('body').append('<script src="'+src+'"></script>');
  }

  else if( type == 'css' ) {
    $('body').append('<link rel="stylesheet" href="'+src+'">');
  }

  else {
    return false;
  }

}
